export default __webpack_public_path__ + "static/media/project-logo.562f8d34.png";